//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  IFacebookPostAttemptFailure,
  IInstagramPostAttemptFailure,
  IPinterestPostAttemptFailure,
  ITikTokPostAttemptFailure,
  ITwitterPostAttemptFailure,
  TScheduledPostAttemptData,
  UniversalScheduledPostAttemptDataType,
} from '@apis/universal-posts/scheduled-posts/postAttempts/universalScheduledPostAttemptsModel';

export const isPinterestPostAttemptFailure = (
  config: TScheduledPostAttemptData,
): config is IPinterestPostAttemptFailure => {
  return (
    config['@typev2'] === UniversalScheduledPostAttemptDataType.PinterestFailure
  );
};

export const isTwitterPostAttemptFailure = (
  config: TScheduledPostAttemptData,
): config is ITwitterPostAttemptFailure => {
  return (
    config['@typev2'] === UniversalScheduledPostAttemptDataType.TwitterFailure
  );
};

export const isInstagramPostFailure = (
  error: TScheduledPostAttemptData,
): error is IInstagramPostAttemptFailure => {
  return (
    error[`@typev2`] ===
    UniversalScheduledPostAttemptDataType.InstagramPostAttemptFailure
  );
};

export const isTikTokPostAttemptFailure = (
  error: TScheduledPostAttemptData,
): error is ITikTokPostAttemptFailure => {
  return (
    error[`@typev2`] === UniversalScheduledPostAttemptDataType.TikTokFailure
  );
};

export const isFacebookPostAttemptFailure = (
  error: TScheduledPostAttemptData,
): error is IFacebookPostAttemptFailure => {
  return (
    error[`@typev2`] ===
    UniversalScheduledPostAttemptDataType.FacebookPostAttemptFailure
  );
};
